import React, { useEffect } from 'react'
import { getRelatedBibliographicRecords } from '../../utils/marc';

const RecordConnectionController = ({ rawMarcRecord, parentGuids = [], children }) => {
  const connectedBibIds = rawMarcRecord ? getRelatedBibliographicRecords(rawMarcRecord) : [];
  const uniqConnectedBibIds = [...(new Set(connectedBibIds.filter(x => !parentGuids.includes(x))))];

  /**
   * Le kell kérni a parentet és a hozzá kapcsolt gyerekeket egyszerre.
   */
  useEffect(() => {
    if(uniqConnectedBibIds?.length > 0) {
      
    }
  }, [uniqConnectedBibIds])

  return children({ uniqConnectedBibIds, parentGuids });
}

export default RecordConnectionController